import request from '@/utils/request';

// 出租管理

// 租车结算

// 租车结算--已结月账单
export function finishListBill(data) {
  return request({
    url: '/share-car-manager/bill/finishList',
    method: 'post',
    data,
  });
}

// 租车结算--待结月账单
export function waitListBill(data) {
  return request({
    url: '/share-car-manager/bill/waitList',
    method: 'post',
    data,
  });
}

// 租车结算--查询单位开票信息
export function invoiceInfo(teamId) {
  return request({
    url: '/share-car-manager/bill/invoiceInfo',
    method: 'get',
    params: { teamId },
  });
}
// 租车结算--操作(去开票、去核账)
export function operate(data) {
  return request({
    url: '/share-car-manager/bill/operate',
    method: 'post',
    data,
  });
}
// 租车结算--操作记录
export function operateRecord(billId) {
  return request({
    url: '/share-car-manager/bill/operateRecord',
    method: 'get',
    params: { billId },
  });
}

// 租车订单--因公明细列表
export function pubListOrder(data) {
  return request({
    url: '/share-car-manager/order/pubList',
    method: 'post',
    data,
  });
}

// 租车订单--平台结束用车
export function finishOrder(data) {
  return request({
    url: '/share-car-manager/order/finishOrder',
    method: 'post',
    data,
  });
}
// 租车订单--费用详情
export function orderFeeDetail(orderId) {
  return request({
    url: '/share-car-user/order/orderFeeDetail',
    method: 'get',
    params: { orderId },
  });
}

// 租车订单--取车验车单
export function pickCarCheck(orderId) {
  return request({
    url: '/share-car-user/order/pickCarCheck',
    method: 'get',
    params: { orderId },
  });
}

// 租车订单--还车验车单
export function backCarCheck(orderId) {
  return request({
    url: '/share-car-user/order/backCarCheck',
    method: 'get',
    params: { orderId },
  });
}

// 租车订单--订单详情
export function getOrderDetail(orderId) {
  return request({
    url: '/share-car-user/order/orderDetail',
    method: 'post',
    data: { orderId },
  });
}

// 租车订单--因私明细列表
export function prListOrder(data) {
  return request({
    url: '/share-car-manager/order/prList',
    method: 'post',
    data,
  });
}


// 计价管理
// 计价管理--因私用车时段查询
export function findPrCarPeriodRule(params) {
  return request({
    url: '/share-car-manager/feeRule/findPrCarPeriodRule',
    method: 'get',
    params,
  });
}
// 计价管理--因私用车时段修改
export function editPrCarPeriodRule(data) {
  return request({
    url: '/share-car-manager/feeRule/editPrCarPeriodRule',
    method: 'post',
    data,
  });
}
// 计价管理--新增或修改
export function addOrEditRule(data) {
  return request({
    url: '/share-car-manager/feeRule/addOrEditRule',
    method: 'post',
    data,
  });
}
// 计价管理--删除
export function deleteRule(params) {
  return request({
    url: '/share-car-manager/feeRule/deleteRule',
    method: 'get',
    params,
  });
}
// 计价管理--导出计价管理列表
export function exportFeeRuleList(data) {
  return request({
    url: '/share-car-manager/feeRule/exportFeeRuleList',
    method: 'post',
    data,
  });
}
// 计价管理--列表
export function feeRulelist(data) {
  return request({
    url: '/share-car-manager/feeRule/list',
    method: 'post',
    data,
  });
}

//还车点管理
// 详情
export function detail(params) {
  return request({
    url: '/share-car-manager/backPlace/detail',
    method: 'get',
    params
  });
}
// 列表
export function list(data) {
  return request({
    url: '/share-car-manager/backPlace/list',
    method: 'post',
    data,
  });
}
// 删除
export function del(params) {
  return request({
    url: '/share-car-manager/backPlace/delete',
    method: 'get',
    params
  });
}
// 新增或修改
export function addOrUpdate(data) {
  return request({
    url: '/share-car-manager/backPlace/addOrUpdate',
    method: 'post',
    data,
  });
}


// 还车点管理--充电桩列表
export function chargeList(placeId) {
  return request({
    url: '/share-car-manager/backPlace/chargeList',
    method: 'post',
    data:placeId
  });
}
// 还车点管理--分配车辆
export function carList(placeId) {
  return request({
    url: '/share-car-manager/backPlace/carList',
    method: 'post',
    data:placeId
  });
}
// 充电桩列表
export function queryCarChareList(data) {
  return request({
      url: '/share-car-manager/charge/queryCarChareList',
      method: 'post',
      data: data
  })
}
// 还车点管理--分配车辆导出
export function exportCarList(data) {
  return request({
    url: '/share-car-manager/backPlace/exportCarList',
    method: 'post',
    data,
  });
}
// 还车点管理--删除还车点车辆
export function deletePlaceCar(params) {
  return request({
    url: '/share-car-manager/backPlace/deletePlaceCar',
    method: 'get',
    params
  });
}
// 还车点管理--删除还车点充电桩
export function deletePlaceCharge(params) {
  return request({
    url: '/share-car-manager/backPlace/deletePlaceCharge',
    method: 'get',
    params
  });
}


// 计价管理--新增或修改计价规则
export function addOrEditShareCarRule(data) {
  return request({
    url: '/share-car-manager/shareCarfeeRule/addOrEditShareCarRule',
    method: 'post',
    data,
  });
}
// 计价管理--列表查询
export function queryShareCarRuleList(data) {
  return request({
    url: '/share-car-manager/shareCarfeeRule/queryShareCarRuleList',
    method: 'post',
    data,
  });
}

// 租车结算

export function settlement(data) {
  return request({
    url: '/share-car-manager/bill/settlement',
    method: 'post',
    data,
  });
}

// 计价管理-列表删除计价规则
export function delShareCarRule(id) {
  return request({
      url: '/share-car-manager/shareCarfeeRule/delShareCarRule',
      method: 'get',
      params: { ruleId: id }
  })
}